/* eslint-disable @typescript-eslint/prefer-for-of */
import _set from 'lodash/set';

export default class ChangesetHelper {
    /**
     * 判断传入的data的path上是否存在数据变更
     * @param visualizeData
     * @param path
     */
    public static dataHasChangeAtPath(visualizeData: any, path: string) {
        // visualizeData=undefined是首次加载数据，此时认为所有路径都有change
        const changed = visualizeData === undefined || (visualizeData && ChangesetHelper.getValue(visualizeData, path));
        return !!changed;
    }

    public static dataChangedAtPath(changesetInfo: Array<any>, path: string) {
        if (!changesetInfo || !path || typeof path !== 'string') return false;
        const formatPath = path.replace(/\./g, '/');
        let changed = false;
        for (let index = 0; index < changesetInfo.length; index++) {
            const changeset = changesetInfo[index];
            if (changeset.path.indexOf(formatPath) >= 0) {
                changed = true;
                break;
            }
        }
        return changed;
    }

    public static getValue(obj, path) {
        let maxNum = 50;
        if (obj && path) {
            const propArr = path.split('.');
            let res = obj;
            while (propArr.length && maxNum > 0) {
                const prop = propArr.shift();
                res = res?.[prop];
                maxNum -= 1;
            }
            if (maxNum <= 0) {
                window.log.error('changeSetHelper getValue over maxNum');
            }
            return res;
        }
    }

    public static newPatchForPath = (patch, path): any => {
        let newPatch = {};
        if (path.length === patch.path.length) {
            newPatch = patch;
        } else {
            _set(newPatch, 'op', 'replace');
            _set(newPatch, 'path', path);

            let valuePath = patch.path.substring(path.length + 1);
            valuePath = valuePath.replace(new RegExp('/', 'g'), '.');
            // 对于删除的路径来说patch.value为undefine, 会被认为此路径无变化
            const value = _set({}, valuePath, patch.value || {});
            _set(newPatch, 'value', value);
        }
        return newPatch;
    };

    public static getAllPath = (data): Array<string> => {
        const paths = [];
        ChangesetHelper.getPath(data, paths, '');// [\\w]+
        return paths.reverse();
    };


    private static getPath = (data, paths, parentPath) => {
        if (data) {
            if (Array.isArray(data)) {
                const currentPath = `${parentPath}/\\d{1,}`;
                if (!paths.includes(currentPath)) {
                    paths.push(currentPath);
                }
                ChangesetHelper.getPath(data[0], paths, currentPath);
            } else {
                const keys = Object.keys(data);
                keys.forEach((key) => {
                    ChangesetHelper.getPath(data[key], paths, `${parentPath}/${key}`);
                });
            }
        } else {
            if (!paths.includes(parentPath)) {
                paths.push(parentPath);
            }
        }
    };
}
